module.exports = __webpack_public_path__ + "img/setup_guidline2.329ed13e.png";